import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Users, CalendarCheck, Shield, ThumbsUp } from 'lucide-react';
const benefits = [{
  icon: Users,
  title: 'Friendly & Trained Teams',
  description: 'Our cleaners are professionally trained, uniformed, and friendly. We take pride in our work.'
}, {
  icon: CalendarCheck,
  title: 'Reliable Scheduling',
  description: 'We show up on time, every time. Flexible booking slots to suit your busy lifestyle.'
}, {
  icon: CheckCircle2,
  title: 'Professional Equipment',
  description: 'We bring all necessary professional-grade equipment and eco-friendly supplies.'
}, {
  icon: Shield,
  title: 'Fully Insured & Vetted',
  description: 'Complete peace of mind with our fully insured services and background-checked staff.'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-20 bg-gray-50" data-id="element-236">
      <div className="container mx-auto px-4 md:px-6" data-id="element-237">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-238">
          {/* Content Side */}
          <div className="lg:w-1/2" data-id="element-239">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-240">
              <div className="inline-block px-4 py-1.5 bg-teal-100 text-teal-700 font-semibold rounded-full text-sm mb-6" data-id="element-241">
                Why Choose Cleen Co
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-242">
                Glasgow's Most Trusted Cleaning Company
              </h2>
              <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-243">
                We believe in delivering more than just a clean space. We
                deliver peace of mind, reliability, and a service you can count
                on week after week.
              </p>

              <div className="grid gap-8" data-id="element-244">
                {benefits.map((benefit, index) => <div key={index} className="flex gap-4" data-id="element-245">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center border border-gray-100" data-id="element-246">
                      <benefit.icon className="w-6 h-6 text-teal-600" data-id="element-247" />
                    </div>
                    <div data-id="element-248">
                      <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-249">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-250">{benefit.description}</p>
                    </div>
                  </div>)}
              </div>

              <div className="mt-10 p-6 bg-teal-600 rounded-2xl text-white flex items-center gap-4 shadow-lg shadow-teal-600/20" data-id="element-251">
                <ThumbsUp className="w-10 h-10 flex-shrink-0" data-id="element-252" />
                <div data-id="element-253">
                  <div className="font-bold text-xl" data-id="element-254">
                    100% Satisfaction Guarantee
                  </div>
                  <div className="text-teal-100 text-sm" data-id="element-255">
                    Not happy? We'll come back and re-clean for free.
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Image/Visual Side */}
          <div className="lg:w-1/2 relative" data-id="element-256">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="relative z-10 grid grid-cols-2 gap-4" data-id="element-257">
              <div className="space-y-4 mt-8" data-id="element-258">
                <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 h-48 flex flex-col justify-center items-center text-center" data-id="element-259">
                  <div className="text-4xl font-bold text-teal-600 mb-2" data-id="element-260">
                    10+
                  </div>
                  <div className="text-gray-600 font-medium" data-id="element-261">
                    Years Experience
                  </div>
                </div>
                <div className="bg-gray-900 p-6 rounded-2xl shadow-lg h-64 flex flex-col justify-center items-center text-center" data-id="element-262">
                  <div className="text-4xl font-bold text-white mb-2" data-id="element-263">2k+</div>
                  <div className="text-gray-400 font-medium" data-id="element-264">Happy Clients</div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-265">
                <div className="bg-teal-600 p-6 rounded-2xl shadow-lg h-64 flex flex-col justify-center items-center text-center" data-id="element-266">
                  <div className="text-4xl font-bold text-white mb-2" data-id="element-267">5.0</div>
                  <div className="flex gap-1 justify-center mb-2" data-id="element-268">
                    {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-2 h-2 bg-white rounded-full" data-id="element-269" />)}
                  </div>
                  <div className="text-teal-100 font-medium" data-id="element-270">
                    Average Rating
                  </div>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 h-48 flex flex-col justify-center items-center text-center" data-id="element-271">
                  <div className="text-4xl font-bold text-teal-600 mb-2" data-id="element-272">
                    100%
                  </div>
                  <div className="text-gray-600 font-medium" data-id="element-273">Vetted Staff</div>
                </div>
              </div>
            </motion.div>

            {/* Decorative blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-teal-100/50 rounded-full blur-3xl -z-10" data-id="element-274" />
          </div>
        </div>
      </div>
    </section>;
}